/*
 reportEditor

 This component represents the report editor.

 */

import $ from 'jquery';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/sortable';
import ko from 'knockout';
import _ from 'lodash';
import { errorHandler } from '../common';

ko.components.register('reportEditor', {
    viewModel: reportEditor,
    template: {
        element: 'report-editor-template'
    }
});


export function reportEditor(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportEditor)
        return data;

    self.mainElement = ko.observable(null);
    self.reportId = ko.observable(data.reportId);
    self.isReportOwner = ko.observable(data.isReportOwner);
    self.report = ko.observable({}).extend({ notify: 'always' });
    self.loadingData = ko.observable(false);
    self.allColumns = [];
    self.reportColumns = ko.observableArray([]);
    self.reportColumnsInitial = ko.observableArray([]); //used for the initial sortable list rendering only
    self.selectedReportColumn = ko.observable({});
    self.validationErrors = ko.observableArray([]);
    self.showDeletePopup = ko.observable(false);
    self.trendTypes = ko.observableArray([{ text: 'None', value: 'None' }, { text: 'Year Over Year', value: 'YearOverYear' }, { text: 'Previous Period', value: 'PreviousPeriod' }]);
    self.trendPeriodCounts = ko.observableArray([{ text: '0', value: 0 }, { text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }, { text: '7', value: 7 }, { text: '8', value: 8 }, { text: '9', value: 9 }, { text: '10', value: 10 }, { text: '11', value: 11 }, { text: '12', value: 12 }, { text: '13', value: 13 }]);
    self.trendType = ko.observable("None"); //None or YearOverYear or PreviousPeriod
    self.trendPeriodCount = ko.observable(0);

    var reportColumnsAreLoaded = ko.observable(false);
    var reportColumnHasBeenSelected = ko.observable(false);

    self.getAllColumnsDataPromise = data.getAllColumnsDataPromise;
    self.getReportDataPromise = data.getReportDataPromise;
    self.deleteReportDataPromise = data.deleteReportDataPromise;
    self.updateReportFullDataPromise = data.updateReportFullDataPromise;
    self.saveReportAsNewDataPromise = data.saveReportAsNewDataPromise;
    self.saveReportFiltersDataPromise = data.saveReportFiltersDataPromise;
    self.onSaveCompletedCallback = data.onSaveCompleted;
    self.onDeleteCompletedCallback = data.onDeleteCompleted;
    self.onCancelCallback = data.onCancel;

    const includedStyle = `
        label {
            position: relative;
        }

        #filter {
            display: none;
        }
    `;

    var updateReportColumnDomElement = function () {
        let showTrend = false;

        const { included } = self.mainElement().querySelector('double-select');

        for (const value of included) {
            var column = self.reportColumns().find(col => col.caption() === value);

            showTrend = showTrend || column && column.showTrend() === true;
        }

        updateIncludedStyle();

        if (showTrend) {
            if (self.trendType() === "None") {
                self.trendType("YearOverYear");
                self.trendPeriodCount(1);
                updateReportTrendType();
            }
        }
    }

    var updateReport = async function (report) {

        //Get a JS version of the columns to send to the API along with the JS report object.
        var reportColumns = ko.mapping.toJS(self.reportColumns());

        for (const [i, column] of reportColumns.entries()) {
            column.columnOrder = i + 1;
        }

        //Call the api
        //We need to save the filters just in case a user overrode them
        const [reportResult, filtersResult] = await Promise.all([
            self.updateReportFullDataPromise(report, reportColumns),
            self.saveReportFiltersDataPromise(report.reportId)]);

        if (_.isFunction(self.onSaveCompletedCallback)) {
            const rpt = await reportResult.json();

            self.onSaveCompletedCallback(rpt.reportId);
        }

        errorHandler.processResponse(filtersResult);
        errorHandler.processResponse(reportResult);
    }

    var saveReportAsNew = async function (report) {

        //Don't set the new report as the user's default.
        report.defaultReport = false;

        //Add the new report to the user's favorites
        report.isFavorite = true;

        //Save to the api
        const response = await self.saveReportAsNewDataPromise(report);

        errorHandler.processResponse(response);

        const reportId = await response.json();

        report.reportId = reportId || -1;

        //Call the update report function so that any column modifications in the editor
        //are applied to the new report that we just saved to the api.
        updateReport(report);
    }

    var deleteReport = function (reportId) {

        self.deleteReportDataPromise(reportId).then(
            function (reportId) {
                if (_.isFunction(self.onDeleteCompletedCallback)) {
                    self.onDeleteCompletedCallback(reportId);
                }
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.deleteConfirmationButtonClick = function (item, event) {
        var reportId = self.report().reportId();
        deleteReport(reportId);
    }

    self.deleteButtonClick = function (item, event) {
        self.showDeletePopup(true);
    }

    self.saveButtonClick = function (item, event) {
        var report = ko.mapping.toJS(self.report());

        updateReport(report);
    }

    self.saveAsNewButtonClick = function (item, event) {

        var report = ko.mapping.toJS(self.report());

        if (self.report().title().trim().length == 0) {
            self.validationErrors.push("The new report title cannot be blank.");
        }

        if (self.report().originalTitle() == self.report().title()) {
            self.validationErrors.push("The new report title cannot match the current one.");
        }

        if (self.validationErrors().length > 0)
            return;

        //Get the current report and reset the title.
        var report = ko.mapping.toJS(self.report());

        saveReportAsNew(report);
    }

    self.cancelButtonClick = function (item, event) {

        if (!_.isNullOrUndefined(self.onCancelCallback)) {
            self.onCancelCallback.call(null, null);
        }
    }

    self.trendTypeChanged = function (newValue) {
        self.trendType(newValue);
        if (newValue === "None") {
            document.getElementById('include-in-comparisons').checked = false;

            self.trendPeriodCount(0);
            _.forEach(self.reportColumns(), function (col) { col.showTrend(true); col.showTrend(false); });
        }
        else if (self.trendPeriodCount() === 0) {
            self.trendPeriodCount(1);
        }
        updateReportTrendType();
    }

    self.trendPeriodCountChanged = function (newValue) {
        self.trendPeriodCount(newValue);
        if (newValue === 0) {
            self.trendType("None");
            _.forEach(self.reportColumns(), function (col) { col.showTrend(false); });
        }
        else if (self.trendType() === "None") {
            self.trendType("YearOverYear");
        }
        updateReportTrendType();
    }

    var updateReportTrendType = function () {
        var trendType = self.trendType();
        var periodCount = self.trendPeriodCount();

        if (periodCount > 0 && (trendType === 'YearOverYear' || trendType === 'PreviousPeriod')) {
            self.report().trendType(trendType + '-' + periodCount);
        }
        else {
            self.report().trendType('None');
        }
    }

    var initTrendProperties = function () {

        //Trend properties are based on the report trendType
        var reportTrendType = self.report().trendType();
        var periodCount = parseInt(reportTrendType.substring(reportTrendType.lastIndexOf("-") + 1));

        self.trendType(reportTrendType.indexOf("YearOverYear") === 0 ? "YearOverYear" : reportTrendType.indexOf("PreviousPeriod") === 0 ? "PreviousPeriod" : "None");
        self.trendPeriodCount(periodCount && periodCount !== NaN ? periodCount : 0);

        updateIncludedStyle();
    }

    var init = function () {

        //Call the promise functions to get report columns and all columns
        if (!_.isNullOrUndefined(self.getReportDataPromise) && !_.isNullOrUndefined(self.getAllColumnsDataPromise)) {

            var args = [self.reportId()];

            self.loadingData(true);

            //Go get the report and columns data...
            $.when(
                self.getReportDataPromise.apply(null, args),
                self.getAllColumnsDataPromise.apply(null, args)).then(
                    function (report, allColumns) {
                        const select = self.mainElement().querySelector('double-select');

                        //no longer loading data
                        self.loadingData(false);

                        //Store all columns here
                        self.allColumns = allColumns;

                        //Get an array of columns that removes duplicates because of trends.
                        var columnsArrayWithDedupedTrendColumns = [];
                        _.forEach(report.columns, function (col) {
                            var found = false;
                            _.forEach(columnsArrayWithDedupedTrendColumns, function (c) {
                                if (col.columnId == c.columnId)
                                    found = true;
                            });
                            if (!found)
                                columnsArrayWithDedupedTrendColumns.push(col);
                        })

                        self.reportColumns(ko.mapping.fromJS(columnsArrayWithDedupedTrendColumns)());

                        self.reportColumnsInitial(columnsArrayWithDedupedTrendColumns); //used for the initial sortable list rendering, then it isn't used.
                        reportColumnsAreLoaded(true);

                        _.forEach(self.reportColumns(), function (column) {
                            subscribeToShowTrend(column);
                        });

                        select.excluded = allColumns
                            .filter(({ columnId }) => !report.columns.find(column => column.columnId === columnId))
                            .map(({ caption }) => caption);

                        select.included = self.reportColumns().map(column => column.caption());

                        //Store the original title
                        report.originalTitle = report.title;

                        //Set the report
                        self.report(ko.mapping.fromJS(report));

                        self.report().defaultReport.subscribe(function (newValue) {
                            if (newValue) {
                                reportsRepo.setDefaultReportId(self.report().reportId());
                            }
                        }, reportEditor);

                        //Populate the trend properties
                        initTrendProperties();
                    },
                    function (errorResult) {
                        //no longer loading data
                        self.loadingData(false);
                    }
                );
        }
    }

    init();

    const mainElementSubscription = self.mainElement.subscribe(element => {
        const select = element.querySelector('double-select');

        document.getElementById('include-in-comparisons').addEventListener('change', handleIncludeInComparisons);

        select.addEventListener('exclude', handleExclude);
        select.addEventListener('include', handleInclude);

        select.addEventListener('includedsort', handleIncludedSort);
        select.addEventListener('includedvaluechange', handleIncludedValueChange);

        select.setAttribute('includedstyle', includedStyle);

        mainElementSubscription.dispose();
    });

    /**
     * Runs when the user removes columns from the report.
     * 
     * Removes the excluded columns from the report columns.
     * 
     * @param {CustomEvent<string[]>} event The exclude event.
     */
    function handleExclude({ detail }) {
        const reportColumns = self.reportColumns();

        for (const column of detail) {
            const index = reportColumns.findIndex(col => col.caption() === column);

            reportColumns.splice(index, 1);
        }

        handleIncludedValueChange();

        updateIncludedStyle();
    }

    /**
     * Runs when the user adds columns to the report.
     * 
     * Adds the included columns to the report columns.
     * 
     * @param {CustomEvent<string[]>} event The include event.
     */
    function handleInclude({ detail }) {
        const { included } = self.mainElement().querySelector('double-select');

        const columns = ko.mapping.fromJS(self.allColumns.filter(({ caption }) => detail.includes(caption)))();

        const newReportColumns = included.map(
            val => self.reportColumns().find(col => col.caption() === val)
                ?? columns.find(col => col.caption() === val)
        );

        for (const column of columns) {
            column.showTrend = ko.observable(false);

            subscribeToShowTrend(column);
        }

        self.reportColumns(newReportColumns);

        handleIncludedValueChange();

        updateIncludedStyle();
    }

    /**
     * Updates the currently selected report column to match the current state of the
     * Include Selected Column In Comparisons checkbox.
     */
    function handleIncludeInComparisons() {
        const { checked } = document.getElementById('include-in-comparisons');

        const { includedValue } = self.mainElement().querySelector('double-select');

        var columns = self.reportColumns().filter(col => includedValue.includes(col.caption()));

        for (const column of columns) {
            column.showTrend(checked);
        }

        updateIncludedStyle();
    }

    /**
     * Runs when the user sorts the columns included in the report.
     * 
     * Sorts the report columns to match the new order.
     * 
     * @param {CustomEvent<string[]>} event The 'includedsort' event.
     */
    function handleIncludedSort({ detail }) {
        self.reportColumns.sort((a, b) => {
            const indexA = detail.indexOf(a.caption());
            const indexB = detail.indexOf(b.caption());

            if (indexA < indexB) {
                return -1;
            }
            if (indexA > indexB) {
                return 1;
            }
            return 0;
        });

        updateIncludedStyle();
    }

    /**
     * Updates the UI to match the currently selected report column.
     */
    function handleIncludedValueChange() {
        const includeInComparisons = document.getElementById('include-in-comparisons')

        const { includedValue } = self.mainElement().querySelector('double-select');

        const columns = self.reportColumns().filter(column => includedValue.includes(column.caption()));

        const showTrend = columns.map(column => Boolean(column?.showTrend()));

        const any = showTrend.some(show => show);

        includeInComparisons.checked = any;

        includeInComparisons.disabled = false;

        includeInComparisons.indeterminate = any && showTrend.some(show => !show);
    }

    /**
     * Subscribes to changes to the specified report column's showTrend property
     * and updates the DOM accordingly.
     * 
     * @param {unknown} column The column to watch.
     */
    function subscribeToShowTrend(column) {
        column.showTrend.subscribe(function (value) {
            updateReportColumnDomElement();
        });
    }

    /**
     * Updates the custom style for the Current Columns menu to match the current state of each column in the report.
     */
    function updateIncludedStyle() {
        const select = self.mainElement().querySelector('double-select');

        let style = includedStyle;

        style += self
            .reportColumns()
            .map((column, i) => ({ column, i }))
            .filter(({ column }) => column.showTrend())
            .map(({ i }) => `
                .value:nth-child(${i + 1}) label::after {
                    content: '\\e162';
                    font-family: 'Glyphicons Halflings';
                    position: absolute;
                    right: 0;
                }
            `)
            .join('');

        select.setAttribute('includedstyle', style);
    }
}
